
import { Component, Prop, Mixins } from 'vue-property-decorator';
import Module from '~/components/Module.vue';
import { DevicesModule } from '~/store/modules/devices';
import { RoomData } from '~/interfaces/rooms.interface';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import moduleFiltering from '~/mixins/moduleFiltering.mixin';

@Component({
    components: {
        Module,
        NetatmoIcon,
    },
})
export default class Room extends Mixins(moduleFiltering) {
    @Prop({ default: () => [] }) modulesData!: any [];
    @Prop() roomData!: RoomData;
    @Prop() panel!: Array<any>;

    get currentModuleId() {
        return DevicesModule.currentModuleId;
    }

    isSelected(moduleId: string) {
        return moduleId === this.currentModuleId;
    }

    moduleData(id: string) {
        return DevicesModule.getDeviceById(id);
    }

    isModuleShown(id: string) {
        const moduleData = this.moduleData(id);
        if (moduleData) {
            return this.isModuleFiltered(moduleData);
        }
    }

    get numberOfDevices() {
        return this.modulesData.length;
    }

    get numberOfDevicesText() {
        return this.numberOfDevices === 0
            ? 'no module'
            : `${this.numberOfDevices} ${this.numberOfDevices > 1 ? 'modules' : 'module'}`;
    }

}
